"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fie-allo-sciliar": {
    "41be2321": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "aica-di-sotto": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "64dc62f8": [{
      "hkey": "e2f391b3",
      "slug": "aica-di-sopra",
      "name": "Aica di Sopra",
      "primary": true,
      "skipSearch": false
    }],
    "aicha-di-sopra": [{
      "hkey": "e2f391b3",
      "slug": "aica-di-sopra",
      "name": "Aica di Sopra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7f65cf77": [{
      "hkey": "4c80b416",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fie-di-sopra": [{
      "hkey": "4c80b416",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "08710055": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "fie-di-sotto": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8e76b995": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "novale-di-fie": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce1caeda": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "novale-di-presule": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e04bf87f": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "passo": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0094eee5": [{
      "hkey": "4c80b416",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "peterbuhel": [{
      "hkey": "4c80b416",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fie-allo-sciliar"
    }],
    "f36e8094": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina": [{
      "hkey": "cd9cbe2d",
      "slug": "fie-allo-sciliar",
      "name": "Fiè allo Sciliar",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;